module.exports = __webpack_public_path__ + "img/Path 25@3x.eef11315.png";